import { DraftWebService, RestfulDraftWebService } from 'ws/DraftWebService';

import {
  DraftCreateDTO,
  DraftValidationDTO,
  DraftPublishResponse
} from './Draft';
import { RtbCampaign } from 'core/rtbCampaign/RtbCampaign';
import { wrapCampaign } from 'ws/RtbCampaignWebService';

export interface DraftManager {
  createDraft(draftCreateDTOList: DraftCreateDTO[]): Promise<void>;
  getValidationInfos(
    draftCreateDTOList: DraftCreateDTO[]
  ): Promise<DraftValidationDTO[]>;
  getDraft(channelGroupId: number, draftId: string): Promise<any>;
  updateDraft(channelGroupId: number, draftId: string, data: any): Promise<any>;
  publishDraft(
    channelGroupId: number,
    draftId: string,
    data: any
  ): Promise<DraftPublishResponse>;
  deleteDrafts(draftIds: (string | number)[]): Promise<any>;
}

export class DefaultDraftManager implements DraftManager {
  webService: DraftWebService;

  constructor(webService: DraftWebService = new RestfulDraftWebService()) {
    this.webService = webService;
  }

  async createDraft(draftCreateDTOList: DraftCreateDTO[]): Promise<void> {
    return this.webService.createDraft(draftCreateDTOList);
  }

  async getValidationInfos(
    draftCreateDTOList: DraftCreateDTO[]
  ): Promise<DraftValidationDTO[]> {
    return this.webService.getValidationInfos(draftCreateDTOList);
  }

  getDraft(_1: number, _2: string): Promise<any> {
    throw new Error('need call inheritance class method instead!');
  }

  updateDraft(_1: number, _2: string, _3: any): Promise<any> {
    throw new Error('need call inheritance class method instead!');
  }

  publishDraft(_1: number, _2: string, _3: any): Promise<any> {
    throw new Error('need call inheritance class method instead!');
  }

  async deleteDrafts(draftIds: (string | number)[]): Promise<any> {
    if (draftIds.length === 0) {
      return;
    }
    return this.webService.deleteDrafts(draftIds);
  }
}

export class RtbCampaignDraftManager extends DefaultDraftManager {
  async getDraft(
    channelGroupId: number,
    draftId: string
  ): Promise<RtbCampaign> {
    const data = await this.webService.getDraft(channelGroupId, draftId);
    return wrapCampaign({
      ...data,
      campaign: {
        ...data.campaign,
        draft: true
      }
    });
  }

  async updateDraft(
    channelGroupId: number,
    draftId: string,
    data: any
  ): Promise<any> {
    return this.webService.updateDraft(channelGroupId, draftId, data);
  }

  async publishDraft(
    channelGroupId: number,
    draftId: string,
    data: any
  ): Promise<any> {
    return this.webService.publishDraft(channelGroupId, draftId, data);
  }
}
